export class DocumentValue {

  key: string;
  value: any;

  constructor(documentValue: any) {
    this.key = documentValue.key;
    this.value = documentValue.value;
  }

}
